import React from 'react';
import { CountStyled } from './styled';
export function Counter({ currentItem, amount, isRightToLeft, className, }) {
    if (!amount) {
        return null;
    }
    return (React.createElement(CountStyled, { isRightToLeft: isRightToLeft, className: className },
        currentItem,
        "/",
        amount));
}
